// extracted by mini-css-extract-plugin
export default {"customSpinner":"style_customSpinner__Qikmj"};